import { useEffect, useState } from "react";
import { getImageFromIndexedDB } from "../../storage/imageStorage";

export default function FoodImage({ imageKey }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!imageKey) return;
    let cancelled = false;
    let url;
    getImageFromIndexedDB(imageKey).then(blob => {
       if (cancelled || !blob) return;
        url = URL.createObjectURL(blob);
        setSrc(url);
      
    });

    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [imageKey]);

  if (!src) return null;
  return <img src={src} width={100} height={100} alt=""/>;
}
